export enum ImageCroppings {
  Square = 'Square',
  Wide = '16:9',
  Tall = '9:16',
}
